import { fromJS, Map } from 'immutable';
import config from 'config';
import actions from 'redux/constants/admin/doctors';
import history from '../../../../history';
import { mapObjIndexed, omit, not } from 'ramda';
import {checkJsonResponse, checkJsonResponseWithMessage, logErrorConsole} from 'utils/actions';

const checkSearchFilter = filter => {
  if(filter) return `?search=${filter}`
  return ''
}

//createDoctor
export const changeDoctorValue = (data, key) => ({
	type: actions.SET_DOCTOR_ITEM_VALUE,
	key,
	data
});

export const doctorIsSubmitting = (data) => ({
  type: actions.DOCTOR_IS_SUBMITTING,
  data
});

export const doctorSubmitFailed = (data) => ({
  type: actions.DOCTOR_CREATE_FAILED,
  data
});

export const doctorUpdateFailed = data => ({
  type: actions.DOCTOR_UPDATE_FAILED,
  data
})

export const doctorChangeItem = (data) => ({
	type: actions.SET_DOCTOR_ITEM,
	data
});

export const doctorDetailIsLoading = (data) => ({
  type: actions.DOCTOR_DETAIL_IS_LOADING,
  data
});


export const loadDoctorDetail = (id) => (dispatch, getState) => {
  dispatch(doctorDetailIsLoading(true));
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  fetch(`${config.apiHost}/doctor/${id}/`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_DOCTOR_DETAIL,
      data
    })
  })
  .catch(logErrorConsole)
  .then(()=> {
    dispatch(doctorDetailIsLoading(false));
  })
};

export const professionsAreLoading = (data) => ({
  type: actions.PROFESSIONS_ARE_LOADING,
  data
});

export const loadProfessions = search => (dispatch, getState) => {
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  dispatch(professionsAreLoading(true));
  return fetch(`${config.apiHost}/profession_classification/${checkSearchFilter(search)}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_PROFESSIONS,
      data
    });
    return data
  })
  .catch(logErrorConsole)
  .then((data)=> {
    dispatch(professionsAreLoading(false))
    return data
  })
};



export const doctorCleanStore = () => (dispatch) => {
  dispatch(doctorChangeItem(new Map({
    email: '',
    last_name: '',
    first_name: '',
    middle_name: '',
    photo: null,
    profession_classification_id: ''
  })));
  dispatch(doctorSubmitFailed(false));
  dispatch(doctorUpdateFailed(false));
};

export const submitDoctor = (url, userData, id) => (dispatch, getState) => {
  dispatch(doctorIsSubmitting(true));
  dispatch(doctorSubmitFailed(false));
  const { profession, photo } = userData
  let rawUserData = omit(['profession'], userData)
  if(typeof photo === 'string') rawUserData = omit(['photo'], rawUserData)

  let method = id ? 'PATCH' : 'POST';
  const userId = getState().doctors.getIn(['doctorDetail', 'user'])
  let path = id ? `${config.apiHost}/user/${userId}/` : `${config.apiHost}/user/generate/`;

  let headers = {
      "Authorization": "Token " + getState().auth.get('token')
    }
  let body

  if(photo) {
    body = new FormData()
    mapObjIndexed((value, key) => body.append(key, value), rawUserData)

    if(not(id)) {
      body.append('profession_classification_id', profession)
    }
  } else {
    headers["Content-type"]='application/json'
    if(not(id)) {
      rawUserData.profession_classification_id = profession
    }
    body = JSON.stringify(rawUserData)
  }

  const options = {
    method,
    headers,
    body
  }

  fetch(path, options)
    .then(checkJsonResponseWithMessage)
    .then((json) => {
      if(id) dispatch(editDoctor(url, id, profession))
      else history.push(`${url}${json.id}`);
    })
    .catch(e => {
      dispatch(doctorSubmitFailed(e));
    })
    .then(() => {
      dispatch(doctorIsSubmitting(false))
    })
};

export const editDoctor = (url, id, profession) => (dispatch, getState) => {
  const userId = getState().doctors.getIn(['doctorDetail', 'user'])

  const dataToSend = {
    'profession_classification': profession,
    user: userId
  }
  let path = `${config.apiHost}/doctor/${id}/`;

  const options = {
    method: 'PUT',
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
      "Content-type": "application/json"
    },
    body: JSON.stringify(dataToSend)
  }

  fetch(path, options)
    .then(checkJsonResponse)
    .then((json) => {
      history.push(`${url}${id}`);
    })
    .catch(e => {
      dispatch(doctorUpdateFailed(true));
    })
    .then(() => {
      dispatch(doctorIsSubmitting(false))
    })
};

export const deleteDoctor = (id) => (dispatch, getState) => {
  const options = {
    method: "delete",
    headers: {
       "Authorization": "Token " + getState().auth.get('token'),
    }
  };
  fetch(`${config.apiHost}/doctor/${id}/`, options)
  .then(response => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return null;
  })
  .then(() => {
    history.push(`/admin/doctors`);
  })
  .catch(e => {
    console.log(e);
  })
};



//doctor
export const doctorsAreLoading = (data) => ({
    type: actions.DOCTORS_ARE_LOADING,
    data
  });

export const searchDoctors = (name="", profession = '', limit=25, offset=0) => (dispatch, getState) => {
    dispatch(doctorsAreLoading(true));
    const options = {
        headers: {
          "Authorization": "Token " + getState().auth.get('token'),
        },
      }
    return fetch(`${config.apiHost}/doctor/?search=${name}&profession_classification=${profession}&limit=${limit}&offset=${offset}`, options)
    .then(checkJsonResponse)
    .then((json) => {
      const data = fromJS(json);
      dispatch({
        type: actions.LOAD_DOCTORS,
        data
      });
      return data
    })
    .catch(e => console.log(e))
    .then((data) => {
      dispatch(doctorsAreLoading(false));
      return data
    })
  };




// WEBPACK FOOTER //
// ./src/redux/actions/admin/doctors/index.js